export const Props = () => ({
  //Список ошибок {key: text}
  errors: {
    type: Object,
    required: false,
  },

  //Данные для инициализации
  initData: {
    type: [Object, null],
    required: false,
  }
});